import { b2cPolicies } from "./Policies";

export const msalConfigLogin = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID,
    authority: b2cPolicies.authorities.signUpSignIn.authority,
    knownAuthorities: [b2cPolicies.authorityDomain],
    redirectUri: process.env.REACT_APP_REDIRECT_URI,
    postLogoutRedirectUri: process.env.REACT_APP_REDIRECT_URI,
  },
};

export const msalConfigReset = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID,
    authority: b2cPolicies.authorities.resetPassword.authority,
    knownAuthorities: [b2cPolicies.authorityDomain],
    redirectUri: process.env.REACT_APP_REDIRECT_URI,
    postLogoutRedirectUri: process.env.REACT_APP_REDIRECT_URI,
  },
};

export const loginRequest = {
  scopes: [
    "https://" +
      process.env.REACT_APP_INSTANCE +
      "/" +
      process.env.REACT_APP_AUTHORITY,
  ],
  prompt: "select_account",
};
